import React, {useEffect, useState} from 'react';
import {RouterState} from '@store/@types/util/ReactRouter';
import {ExternalCallCardSource} from '@store/call-card/external/ExternalCallCardSource';
import {ResponseStatus} from 'utils/ResponseStatus';
import NotFoundPage from '@components/not-found';
import {browserHistory} from 'react-router';

interface InternalShareRedirectProps extends RouterState<{permalink: string}> {}

export const InternalShareRedirect: React.FC<InternalShareRedirectProps> = ({params}) => {
  const [status, setStatus] = useState<ResponseStatus>();
  useEffect(() => {
    ExternalCallCardSource.login(params.permalink, '').then(({status, callId}) => {
      setStatus(status);
      if (status === ResponseStatus.OK) {
        browserHistory.push(`/call/${callId}`);
      }
    });
  }, [params.permalink]);

  if (status === ResponseStatus.NOT_FOUND) {
    return <NotFoundPage>We could not find the share that you were looking for.</NotFoundPage>;
  }

  if (status === ResponseStatus.GONE) {
    return (
      <NotFoundPage title="410" subtitle="Expired">
        The share you were looking for has expired.
      </NotFoundPage>
    );
  }

  return null;
};
